<template>
  <v-card
    :class="[
      { 'reminder-card-glow': !completed },
      completed ? 'ma-3 mr-12' : 'ma-3 mr-0 ml-12',
      active ? 'blue-grey lighten-5' : '',
    ]"
    @dblclick="$emit('try-edit-note')"
  >
    <v-chip :color="completed ? 'info' : 'green'" label class="d-flex">
      <v-card-title class="pl-2">
        <v-icon left :color="completed ? 'white' : 'red'"> mdi-alarm </v-icon>
        <span class="font-weight-bold">{{ note.reminderType | capitalizeAllWords }} - {{ note.title }}</span>
      </v-card-title>
    </v-chip>
    <div class="d-flex flex-row">
      <v-card-text>
        <div v-if="note.note" v-html="note.note"><br /></div>
      </v-card-text>
      <div class="d-flex flex-column flex-shrink-0">
        <v-card-subtitle class="py-1">
          <div class="blue-grey--text text--lighten-2 text-right">
            {{ note.createdAt | fancyDate }}
          </div>
        </v-card-subtitle>
        <v-card-text class="d-flex flex-row-reverse text-h5 pb-0">
          <v-icon v-if="!completed && soon" class="ml-2" color="red">mdi-alarm</v-icon>
          {{ note.reminderDate | daysAgo }}
        </v-card-text>
        <div class="text-h6 ml-auto pr-4">
          {{ note.reminderDate | fancyShortDate }}
        </div>
      </div>
    </div>
    <v-card-actions class="justify-space-between">
      <div class="ml-n2">
        <v-card-title class="d-inline-flex pb-3">
          <div class="blue-grey--text text--lighten-2 ml-auto">
            <span>{{ note.coach }}</span>
          </div>
        </v-card-title>
      </div>

      <div class="mt-auto d-flex flex-row">
        <v-checkbox label="Complete" hide-details class="mt-2 mr-1" @change="updateReminder($event)" />
        <v-btn small @click="$emit('edit-note')" class="ma-2 mr-0">Edit</v-btn>
        <v-btn small color="error" @click="$emit('delete-note')" class="ma-2">Delete</v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { USER_NOTE_COMPLETE_REMINDER_MUTATION } from "@/constants/graphql/coach/notes";
import { capitalizeAllWords } from "@/lib/string";
import { fancy_date, daysAgo } from "@/lib/fancy_date";

export default {
  name: "ReminderCard",
  props: {
    note: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      completed: this.note.reminderCompleted,
    };
  },
  filters: {
    capitalizeAllWords(string) {
      return capitalizeAllWords(string);
    },
    daysAgo(date) {
      return daysAgo(date);
    },
    fancyShortDate(date) {
      return fancy_date(date, "D MMMM YYYY", false);
    },
    fancyDate(date) {
      return fancy_date(date);
    },
  },
  computed: {
    soon() {
      let days = this.$moment().diff(this.note.reminderDate, "days");
      return days > -4;
    }
  },
  methods: {
    updateReminder(completed) {
      this.completed = completed;

      this.$apollo
        .mutate({
          mutation: USER_NOTE_COMPLETE_REMINDER_MUTATION,
          variables: {
            id: this.note.id,
            completed: this.completed,
          },
          refetchQueries: ["userNotes"],
        })
        .catch((error) => {
          this.$emit("problem");
          this.problemConnecting = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.reminder-card-glow {
  box-shadow: 0px 2px 4px -1px var(--v-green-base), 0px 4px 5px 0px var(--v-green-base),
    0px 1px 10px 0px var(--v-green-base) !important;
}
</style>
